import 'react-app-polyfill/ie11';
import 'core-js/features/array/find';
import 'core-js/es';

import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import * as serviceWorker from './serviceWorker';
import Router from './Router';

import 'bootstrap/dist/css/bootstrap.min.css';
import './assets/styles/shards-dashboards.1.1.0.min.css';
import {GlobalDataContextProvider} from "./contexts/GlobalDataContext";


import { createBrowserHistory } from 'history';

const history = createBrowserHistory();

// eslint-disable-next-line no-restricted-globals
const path = (/#!(\/.*)$/.exec(location.hash) || [])[1];

if (path) {
    history.replace(path);
}

ReactDOM.render(
    <GlobalDataContextProvider>
        <Router/>
    </GlobalDataContextProvider>,
    document.getElementById('root'));

serviceWorker.unregister();
